import {
  BADGE_TYPE_ACTIVE,
  BADGE_TYPE_DANGER,
  BADGE_TYPE_DARK,
  BADGE_TYPE_INFO,
  BADGE_TYPE_MUTED,
  BADGE_TYPE_NEW,
  BADGE_TYPE_PRIMARY,
  BADGE_TYPE_TRANSPARENT
} from '@/constants/theme.constants.js'

export const PROFILE_SOCIAL_LINK_TYPES = [
  'linkedin',
  'website'
]

export const WORK_NOTICE_PERIODS_IMMEDIATELY = 'immediately'
export const WORK_NOTICE_PERIODS = [
  WORK_NOTICE_PERIODS_IMMEDIATELY,
  '1_week',
  '2_weeks',
  '3_weeks',
  '1_month',
  '2_months',
  '3_months',
  '4_months',
  '6_months'
]

export const PROFILE_SEARCH_STATUS_ACTIVE = 'active'
export const PROFILE_SEARCH_STATUS_PASSIVE = 'passive'
export const PROFILE_SEARCH_STATUS_OFFLINE = 'offline'

export const PROFILE_SEARCH_STATUSES = [
  {
    name: PROFILE_SEARCH_STATUS_ACTIVE,
    icon: 'success'
  },
  {
    name: PROFILE_SEARCH_STATUS_PASSIVE,
    description: true,
    icon: 'passive'
  },
  {
    name: PROFILE_SEARCH_STATUS_OFFLINE,
    description: true,
    icon: 'disabled'
  }
]

export const PROFILE_REJECTION_REASONS = [
  'salary',
  'too_many_changes',
  'insufficient_training',
  'lack_language_skill',
  'missing_documents',
  'career_changer',
  'industry_and_market_knowledge',
  'no_matching_vacancies',
  'no_response',
  'experience',
  'custom_reason'
]

export const PROFILE_STATUS_UNFINISHED = 'unfinished'
export const PROFILE_STATUS_NEW = 'new'
export const PROFILE_STATUS_REJECTION = 'rejection'
export const PROFILE_STATUS_REJECTION_DELETION = 'rejection_deletion'
export const PROFILE_STATUS_PROFILE_REJECTION = 'profile_rejection'
export const PROFILE_STATUS_IN_PROGRESS = 'in_progress'
export const PROFILE_STATUS_INTERVIEW = 'interview'
export const PROFILE_STATUS_ACTIVE = 'active'
export const PROFILE_STATUS_OFFLINE = 'offline'
export const PROFILE_STATUS_REAPPLIED = 'reapplied'

export const PROFILE_STATUSES = [
  PROFILE_STATUS_UNFINISHED,
  PROFILE_STATUS_NEW,
  PROFILE_STATUS_IN_PROGRESS,
  PROFILE_STATUS_INTERVIEW,
  PROFILE_STATUS_REJECTION,
  PROFILE_STATUS_REJECTION_DELETION,
  PROFILE_STATUS_PROFILE_REJECTION,
  PROFILE_STATUS_ACTIVE,
  PROFILE_STATUS_OFFLINE,
  PROFILE_STATUS_REAPPLIED
]

export const PROFILE_STATUS_BADGES = {
  [PROFILE_STATUS_UNFINISHED]: BADGE_TYPE_DANGER,
  [PROFILE_STATUS_NEW]: BADGE_TYPE_NEW,
  [PROFILE_STATUS_REJECTION]: BADGE_TYPE_TRANSPARENT,
  [PROFILE_STATUS_ACTIVE]: BADGE_TYPE_ACTIVE,
  [PROFILE_STATUS_REJECTION_DELETION]: BADGE_TYPE_DARK,
  [PROFILE_STATUS_IN_PROGRESS]: BADGE_TYPE_INFO,
  [PROFILE_STATUS_INTERVIEW]: BADGE_TYPE_PRIMARY,
  [PROFILE_STATUS_OFFLINE]: BADGE_TYPE_TRANSPARENT,
  [PROFILE_STATUS_REAPPLIED]: BADGE_TYPE_MUTED
}

export const PROFILE_ACTIVE_STATUSES = [
  PROFILE_STATUS_ACTIVE,
  PROFILE_STATUS_OFFLINE
]

export const PROFILE_NEW_STATUSES = [
  PROFILE_STATUS_UNFINISHED,
  PROFILE_STATUS_NEW
]

export const PROFILE_REJECTION_STATUSES = [
  PROFILE_STATUS_REJECTION,
  PROFILE_STATUS_REJECTION_DELETION,
  PROFILE_STATUS_PROFILE_REJECTION
]

export const INTERVIEW_STATUS_NEW = 'new'
export const INTERVIEW_STATUS_CANCELED = 'canceled'
export const INTERVIEW_STATUS_FINISHED = 'finished'

export const PROFILE_INTERVIEW_STATUSES = [
  INTERVIEW_STATUS_NEW,
  INTERVIEW_STATUS_CANCELED,
  INTERVIEW_STATUS_FINISHED
]

export const PROFILE_SEARCH_STATUSES_FILTER = [
  PROFILE_SEARCH_STATUS_ACTIVE,
  PROFILE_SEARCH_STATUS_PASSIVE,
  PROFILE_SEARCH_STATUS_OFFLINE
]
